import * as React from 'react'

import './alert.css'
/**
 * Alert
 * variant: "default" | "destructive"
 */
export function Alert({
  variant = 'default',
  className = '',
  ...props
}) {
  return (
    <div
      data-slot="alert"
      role="alert"
      className={`alert alert-${variant} ${className}`}
      {...props}
    />
  )
}

/**
 * AlertTitle
 */
export function AlertTitle({ className = '', ...props }) {
  return (
    <div
      data-slot="alert-title"
      className={`alert-title ${className}`}
      {...props}
    />
  )
}

/**
 * AlertDescription
 */
export function AlertDescription({ className = '', ...props }) {
  return (
    <div
      data-slot="alert-description"
      className={`alert-description ${className}`}
      {...props}
    />
  )
}
